<template>
	<div>
		
		<el-dialog :visible.sync="showmodal" title="Update Status" width="30%" @close="$emit('close-modal')">
			<div class="particulars-img-wrapper">
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Current Status</label>
							<input type="text" v-model="capStatus" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Updated By</label>
							<input type="text" v-model="updatedBy" class="input" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">Date Last Updated</label>
							<el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
							v-model="lastUpdated" />
						</div>
						<div class="col-md-12 col-lg-12 col-12">
							<label for="" class="label">New status</label>
							<el-select v-model="statusobj.newstatus" placeholder="Select state">
								<el-option v-for="status in statuses" :key="status" :label="capitalize(status.name)" :value="status.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
			</div>

			<div class="button-wrapper">
				<button @click="$emit('close-modal')">Cancel</button>
				<base-button text="Update" :disabled="checkFields" :loading="loading" @click="updateStatus" />
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
export default {
	props : {
		showmodal : String,
		dispatchId : String,
		currentStatus : String,
		lastUpdated : String,
		statuses : Array
	},
	data() {
		return {
			statusobj : this.getform(),
			loading : false,
			updatedBy : this.$store.getters.user.firstname + " " + this.$store.getters.user.lastname,
		}
	},
	methods : {
		getform(){
			return {
				newstatus : "",
				message : "",
			}
		},
		async updateStatus(){
			let request = {
				dispatchStatus : this.statusobj.newstatus,
				message : "Status Updated to " + this.statusobj.newstatus,
				userId : this.$store.state.authentication.quantumUserId
			}

			try{
				this.loading = true

				await this.$_modifyDispatch(this.dispatchId, request)

				this.loading = false 
				this.$emit('refetch-dispatch')
				this.$emit('close-modal')
			}catch(error){
				this.loading = false;
				this.handleError(error);
			}
			
		},
		// capitalize(str){
        //     let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1)

        //     return capitalizedstr
        // },
		capitalize(str) {
			if (!str || typeof str !== 'string') return ''
			return str.charAt(0).toUpperCase() + str.slice(1)
		}

	},
	computed : {
		checkFields(){
			return this.updatedBy.length == 0 || this.statusobj.newstatus.length == 0 ? true : false
		},
		capStatus() {
			return this.capitalize(this.currentStatus)
		}
	}
}
</script>